import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Visa = memo((props: IconProps) => {
    const { color = "#0E0E0E", ...rest } = props
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...rest}>
            <path
                d="M13.058 7.314s.211 1.033.259 1.25h-.928c.092-.247.444-1.208.444-1.208-.005.008.092-.253.148-.414l.077.372zM16 3.11v9.778c0 .736-.597 1.333-1.333 1.333H1.333A1.334 1.334 0 010 12.89V3.11c0-.736.597-1.333 1.333-1.333h13.334c.736 0 1.333.597 1.333 1.333zM4.236 10.09l1.756-4.311h-1.18L3.718 8.722 3.6 8.125l-.389-1.983c-.064-.275-.261-.353-.505-.364H.908l-.02.086c.44.111.831.272 1.173.475l.995 3.75h1.18zm2.622.005l.7-4.316H6.442l-.698 4.317h1.114zm3.886-1.41c.006-.492-.294-.867-.936-1.176-.391-.197-.63-.33-.63-.533.005-.183.203-.372.641-.372.364-.008.631.078.831.164l.1.047.153-.933a2.775 2.775 0 00-1-.184c-1.103 0-1.878.59-1.884 1.428-.008.62.556.964.978 1.172.43.211.578.35.578.536-.006.29-.35.423-.67.423-.444 0-.683-.07-1.047-.23l-.147-.07-.155.97c.26.118.744.224 1.244.23 1.172.002 1.936-.578 1.944-1.473zm3.923 1.41l-.9-4.316h-.864c-.267 0-.47.078-.584.358l-1.658 3.958h1.172l.234-.647H13.5c.033.153.133.648.133.648h1.034z"
                fill={color}
            />
        </svg>
    )
})

export default Visa
